import React, { useState, useEffect, useContext } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { Controller, useForm } from "react-hook-form";
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, } from "reactstrap";
import Switch from "react-switch";
import { useDispatch, useSelector } from "react-redux";
import { API, BuisnessTypeExcel, EMPTY_DATA, defaultPageSize } from "../../../../../../config/constants";
import { reactLocalStorage } from "reactjs-localstorage";

import _ from "lodash";
import ReactExport from "react-export-excel";
import { useHistory } from "react-router-dom";
import { PaginationWrapper } from "../../../../../common/commonPagination";
import LoaderCustom from "../../../../../common/LoaderCustom";
import DayTime from "../../../../../common/DayTimeWrapper";
import { apiErrors, handleDepartmentHeader, searchNocontentFilter, setLoremIpsum, userDetails } from "../../../../../../helper";
import CustomDateRangeFilter from "../../../../supplierNewRequestHistory/common/CustomDateRangeFilter ";
import { EXCEPTION_APPROVAL_LIST_M } from "../../../../../../config/masterData";
import { ApplyPermissionExceptionApproval } from "../../../../ExceptionalApproval";
import NoContentFound from "../../../../../common/NoContentFound";
import axiosHelper from "../../../../../../axiosHelper";


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const gridOptions = {};

const KysTwoExceptionalApprovalList = (props) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const formController = useForm({
        defaultValues: {},
        mode: "onChange",
        reValidateMode: "onChange",
    });
    let {
        control: popFormControl,
        formState: { errors: popFormErrors },
        register: popFormRegister,
        handleSubmit,
        getValues,
        setValue,
        reset,

    } = formController;

    const [state, setState] = useState({
        isEditFlag: false,
        isOpenVendor: false,
        shown: false,
        ID: "",
        tableData: [],
        city: [],
        country: [],
        state: [],
        showPopup: false,
        deletedId: "",
        cellData: {},
        cellValue: "",
        showPopupToggle: false,
        isViewMode: false,
        isLoader: false,
        selectedRowData: false,
        noData: false,
        dataCount: 0,
        type: "",
        render: false,
        showExtraData: false,
    });
    const [submitionLoading, setSubmitionLoading] = useState(false);
    const [noData, setNoData] = useState(false);
    const [loader, setloader] = useState(false);
    const [exceptionalApprovalTrackingList, setExceptionalApprovalTrackingList] = useState([]); // DONT DELETE THIS STATE , IT IS USED BY AG GRID
    console.log('exceptionalApprovalTrackingList: ', exceptionalApprovalTrackingList);



    /**
    * @method onFloatingFilterChanged
    * @description Filter data when user type in searching input
    */
    const onFloatingFilterChanged = (value) => {
        setTimeout(() => {
            if (exceptionalApprovalTrackingList.length !== 0) {
                setState((prevState) => ({
                    ...prevState,
                    noData: searchNocontentFilter(value, prevState.noData),
                }));
            }
        }, 500);
    };

    const getExceptionalApprovalTrackingList = (requestId) => {
        const userDetail = userDetails();
        let employeeId = parseInt(userDetail?.EmployeeId);
        axiosHelper.get(`${API.getExceptionalApprovalTrackingList}?employeeId=${employeeId}&VendorRequirementRegistrationId=${requestId}`)
            .then(async (response) => {

                if (response?.data?.IsSuccessful) {
                    setExceptionalApprovalTrackingList(response?.data?.Data)
                }
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    apiErrors(error)
                  }
            });
    }

    const onRowSelect = () => {
        const selectedRows = state.gridApi?.getSelectedRows();
        setState((prevState) => ({
            ...prevState,
            selectedRowData: selectedRows,
            dataCount: selectedRows.length,
        }));
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("VendorRequirementRegistrationId");
        if (id) {
            getExceptionalApprovalTrackingList(id)
        }
    }, []);

    const isFirstColumn = (params) => {
        var displayedColumns = params.columnApi.getAllDisplayedColumns();
        var thisIsFirstColumn = displayedColumns[0] === params.column;
        return thisIsFirstColumn;
    };
    const defaultColDef = {
        resizable: true,
        filter: true,
        sortable: false,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: isFirstColumn,
    };
    const onGridReady = (params) => {
        window.screen.width >= 1600 && params.api.sizeColumnsToFit();
        setState((prevState) => ({
            ...prevState,
            gridApi: params.api,
            gridColumnApi: params.columnApi,
        }));
        params.api.paginationGoToPage(0);
    };

    const onPageSizeChanged = (newPageSize) => {
        state.gridApi.paginationSetPageSize(Number(newPageSize));
    };

    if (submitionLoading) {
        return (
            <div>
                {" "}
                <LoaderCustom customClass="simulation-Loader" />
            </div>
        ); // Render loading indicator if loading is true
    }
    const statusButtonFormatter = (cell, row, enumObject, rowIndex) => {
        return (
            <>
                <label htmlFor="normal-switch" className="normal-switch">
                    <Switch
                        // onChange={() => handleChange(cell, row, enumObject,1 rowIndex)}
                        checked={cell}
                        background="#ff6600"
                        onColor="#4DC771"
                        onHandleColor="#ffffff"
                        id="normal-switch"
                        height={24}
                    />
                </label>
            </>
        );
    };

    const reasonRenderer = (props) => {
        let reasons = props?.data?.ExeptionalFlowReasonList;
        // const categories = props.value;
        const reasonCount = reasons.length;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [dropdownOpen, setDropdownOpen] = useState(false);
        const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

        if (reasonCount === 0) {
            return <span>No Reasons</span>;
        }

        if (reasonCount === 1) {
            return <span>{reasons[0]}</span>;
        }

        const visibleReasons = reasons.slice(0, 1); // Show only the first category
        const hiddenReasons = reasons.slice(1); // Hide the first category, rest will go in dropdown

        return (
            <div className="hl-category-count">
                <span className="hl-category-names">{visibleReasons}</span>
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                    <DropdownToggle caret={false} className="hl-category-count-btn">
                        +{reasonCount - 1} more
                    </DropdownToggle>
                    <DropdownMenu container="body" className="hl-cat-menu">
                        {hiddenReasons?.map((reason, index) => (
                            <DropdownItem
                                key={index}
                                className="hl-cat-menu-item"
                            // onClick={() => handleDropdownItemClick(category)}
                            >
                                {reason}
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                </Dropdown>
            </div>
        );
    };

    const effectiveDateFormatter = (props) => {
        const cellValue = props?.valueFormatted
            ? props.valueFormatted
            : props?.value;
        return cellValue != null ? DayTime(cellValue).format("DD/MM/YYYY") : "";
    };
    const checkBoxRenderer = (props) => {
        let selectedRowForPagination =
            reactLocalStorage.getObject("selectedRow").selectedRow;
        const cellValue = props?.valueFormatted
            ? props.valueFormatted
            : props?.value;
        if (selectedRowForPagination?.length > 0) {
            selectedRowForPagination.map((item) => {
                if (item.ApplicationID === props.node.data.ApplicationID) {
                    props.node.setSelected(true);
                }
                return null;
            });
            return cellValue;
        } else {
            return cellValue;
        }
    };
    /**
     * @method effectiveDateFormatter
     * @description Renders buttons
     */
    const requestedOnFormatter = (props) => {
        const cell = props?.valueFormatted ? props.valueFormatted : props?.value;
        return cell != null ? DayTime(cell).format('DD/MM/YYYY') : '-';
    }

    const frameworkComponents = {
        customFloatingFilter: CustomDateRangeFilter,
        statusButtonFormatter: statusButtonFormatter,
        effectiveDateFormatter: effectiveDateFormatter,
        requestedOnFormatter: requestedOnFormatter,
        reasonRenderer: reasonRenderer,
        // hyphenFormatter: hyphenFormatter,
        customNoRowsOverlay: NoContentFound,
        checkBoxRenderer: checkBoxRenderer,
        // valuesFloatingFilter: SingleDropdownFloationFilter,
    };

    return (
        <>
            <>
                <>
                    {loader && <LoaderCustom customClass="simulation-Loader" />}
                    <Row className="ag-grid-react">
                        <Col>
                            <div
                                className={`ag-grid-wrapper overlay-contain ${exceptionalApprovalTrackingList && !noData
                                    ? "master-approval-overlay"
                                    : ""
                                    } ${(exceptionalApprovalTrackingList &&
                                        exceptionalApprovalTrackingList?.length <= 0) ||
                                        noData
                                        ? "overlay-contain"
                                        : ""
                                    }`}
                            >
                                <div
                                    className={`ag-theme-material ${loader && "max-loader-height"
                                        }`}
                                >
                                    {noData && (
                                        <NoContentFound
                                            title={EMPTY_DATA}
                                            customClassName="no-content-found"
                                        />
                                    )}
                                    {/* <Row className={`filter-row-large`}>
                                        <Col md="3" className="mb-2">
                                            <h1>Exception Approval List</h1>
                                        </Col>
                                    </Row> */}
                                    <AgGridReact
                                        defaultColDef={defaultColDef}
                                        floatingFilter={true}
                                        domLayout="autoHeight"
                                        rowData={
                                            state.showExtraData && exceptionalApprovalTrackingList
                                                ? [
                                                    ...setLoremIpsum(exceptionalApprovalTrackingList[0]),
                                                    ...exceptionalApprovalTrackingList,
                                                ]
                                                : exceptionalApprovalTrackingList
                                        }
                                        pagination={true}
                                        paginationPageSize={defaultPageSize}
                                        onGridReady={onGridReady}
                                        gridOptions={gridOptions}
                                        noRowsOverlayComponent={"customNoRowsOverlay"}
                                        noRowsOverlayComponentParams={{
                                            title: EMPTY_DATA,
                                            imagClass: "imagClass",
                                        }}
                                        rowSelection={"multiple"}
                                        suppressRowClickSelection={true}
                                        onSelectionChanged={onRowSelect}
                                        onFilterModified={onFloatingFilterChanged}
                                        frameworkComponents={frameworkComponents}
                                    >
                                        <AgGridColumn
                                            cellClass="has-checkbox"
                                            // field="vendorRequirementRegistrationId"
                                            field="RequestType"
                                            floatingFilter={true}
                                            headerName="Request Type"
                                            cellRenderer={checkBoxRenderer}
                                        ></AgGridColumn>
                                         {/* <AgGridColumn
                                            cellClass="has-checkbox"
                                            // field="vendorRequirementRegistrationId"
                                            field="RequestSequence"
                                            floatingFilter={true}
                                            headerName="Exception Request Sequence"
                                            cellRenderer={checkBoxRenderer}
                                        ></AgGridColumn> */}
                                        <AgGridColumn
                                            cellClass="has-checkbox"
                                            // field="vendorRequirementRegistrationId"
                                            field="Reason"
                                            floatingFilter={true}
                                            headerName="Reason"
                                            cellRenderer={checkBoxRenderer}
                                        ></AgGridColumn>
                                        
                                        
                                        <AgGridColumn
                                            field="EmployeeCode"
                                            sortable={true}
                                            unSortIcon={true}
                                            filter={true}
                                            floatingFilter={true}
                                            headerName="Employee Code"
                                            comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                                valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                            }
                                        // cellRenderer={checkBoxRenderer}
                                        ></AgGridColumn>
                                         <AgGridColumn
                                            field="Position"
                                            sortable={true}
                                            unSortIcon={true}
                                            filter={true}
                                            floatingFilter={true}
                                            headerName="Position"
                                            comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                                valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                            }
                                        // cellRenderer={checkBoxRenderer}
                                        ></AgGridColumn>
                                        <AgGridColumn
                                            field="ApproverName"
                                            headerName="Approver Name"
                                            floatingFilter={true}
                                            sortable={true}
                                            unSortIcon={true}
                                            comparator={(valueA, valueB, nodeA, nodeB, isInverted) =>
                                                valueA.toLowerCase().localeCompare(valueB.toLowerCase())
                                            }
                                        // cellRenderer={checkBoxRenderer}
                                        ></AgGridColumn>
                                        {/* <AgGridColumn
                                            field="ExpectedDateofCorrection"
                                            headerName="Expected Date of Correction"
                                            filter="agDateColumnFilter"
                                            cellRenderer={"effectiveDateFormatter"}
                                            filterParams={{
                                                comparator: (filterDate, cellValue) => {
                                                    // Parse the cellValue string to a Date object
                                                    const cellDate = new Date(cellValue);
                                                    // Remove the time part from both dates to only compare the date part
                                                    const filterDateOnly = new Date(filterDate).setHours(0, 0, 0, 0);
                                                    const cellDateOnly = cellDate.setHours(0, 0, 0, 0);

                                                    if (cellDateOnly < filterDateOnly) return -1;
                                                    if (cellDateOnly > filterDateOnly) return 1;
                                                    return 0;
                                                },
                                                inRangeInclusive: true, // Include start and end values in the range
                                                filterOptions: ["equals", "inRange"],
                                                browserDatePicker: true,
                                                closeOnApply: true,
                                                minValidYear: 2000,
                                            }}
                                        ></AgGridColumn> */}
                                        <AgGridColumn
                                            field="RequestDate"
                                            headerName="Request Date"
                                            filter="agDateColumnFilter"
                                            cellRenderer={"effectiveDateFormatter"}
                                            filterParams={{
                                                comparator: (filterDate, cellValue) => {
                                                    // Parse the cellValue string to a Date object
                                                    const cellDate = new Date(cellValue);
                                                    // Remove the time part from both dates to only compare the date part
                                                    const filterDateOnly = new Date(filterDate).setHours(0, 0, 0, 0);
                                                    const cellDateOnly = cellDate.setHours(0, 0, 0, 0);

                                                    if (cellDateOnly < filterDateOnly) return -1;
                                                    if (cellDateOnly > filterDateOnly) return 1;
                                                    return 0;
                                                },
                                                inRangeInclusive: true, // Include start and end values in the range
                                                filterOptions: ["equals", "inRange"],
                                                browserDatePicker: true,
                                                closeOnApply: true,
                                                minValidYear: 2000,
                                            }}
                                        ></AgGridColumn>
                                         <AgGridColumn
                                            cellClass="has-checkbox"
                                            // field="vendorRequirementRegistrationId"
                                            field="ApprovelLevel"
                                            floatingFilter={true}
                                            headerName="Approvel Level"
                                            valueFormatter={(params) =>
                                                `Approval Level - ${params.value} `
                                              }
                                        ></AgGridColumn>
                                        <AgGridColumn
                                            field="RequesterRemark"
                                            floatingFilter={true}
                                            sortable={false}
                                            headerName="Requester Remark"
                                        // cellRenderer={checkBoxRenderer}
                                        ></AgGridColumn>
                                        <AgGridColumn
                                            field="ApproverRemark"
                                            floatingFilter={true}
                                            sortable={false}
                                            headerName="Approver Remark"
                                        // cellRenderer={checkBoxRenderer}
                                        ></AgGridColumn>
                                        <AgGridColumn
                                            field="ApprovalStatus"
                                            sortable={false}
                                            floatingFilter={true}
                                            headerName="Approval Status"
                                        //  cellRenderer={checkBoxRenderer}
                                        ></AgGridColumn>
                                    </AgGridReact>
                                    {/* )} */}
                                    {/* Add a new AgGridColumn for buttons */}
                                    {
                                        <PaginationWrapper
                                            gridApi={state.gridApi}
                                            setPage={onPageSizeChanged}
                                        />
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                </>
            </>
        </>
    );
};
export default KysTwoExceptionalApprovalList;
